export default __webpack_public_path__ + "static/mingling-e4ef0430f2a69fa58c6784ccd6dc3e76.svg";